<template>
    <div>
        <div class="form-group ">
            <label>{{ __("forms.SatisfactionSurvey.name") }}</label>
            <input type="text" class="form-control" name="kPISegment[name]" required v-model="dataSegmentation.name"
                :disabled="is_archived">
        </div>

        <!-- Lineare / Scaglioni -->
        <div class="form-group">
            <label>{{ __("forms.KPISegments.type_calculation") }}</label>
            <div class="row">

                <!-- If persisted and typology != number, show just calculation step -->
                <div class="col-10" v-if="is_persisted">

                    <select class="form-control" required name="kPISegment[type_segments]" @change="setStaticTypology()"
                        v-model="dataSegmentation.type_segments" :disabled="is_archived">
                        <option value="step">{{ __("forms.KPISegments.calculation_step") }}</option>
                        <option v-if="dataSegmentation.typology == 'number' || dataSegmentation.typology == 'date'" value="line">
                            {{ __("forms.KPISegments.calculation_line") }}</option>
                    </select>
                </div>
                <div class="col-10" v-if="!is_persisted">
                    <select class="form-control" required name="kPISegment[type_segments]" @change="setStaticTypology()"
                        v-model="dataSegmentation.type_segments" :disabled="is_archived">
                        <option value="">{{ __("misc.select") }}</option>
                        <option value="step">{{ __("forms.KPISegments.calculation_step") }}</option>
                        <option value="line">{{ __("forms.KPISegments.calculation_line") }}</option>
                    </select>
                </div>
                <div class="col-1">
                    <button type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mx-1 hrt-button"
                        @click="openNote(__('forms.KPISegments.explain_type_calculation'))">
                        <i class="fas fa-info-circle"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Quantitativo / Qualitativo Data / Testuale -->
        <div class="form-group">
            <div class="row">
                <div v-if="!is_persisted" class="col-10">                    
                    <div class="form-group">
                        <label>{{ __("forms.KPISegments.typology") }}</label>                        
                        <select class="form-control" required name="kPISegment[typology]" v-model="dataSegmentation.typology">
                            <option value="">{{ __("misc.select") }}</option>
                            <option v-for="(typology) in typologies" :value="typology.id" v-bind:key="typology.id" v-show="!(typology.id == 'text' && dataSegmentation.type_segments == 'line')">
                                {{ typology.value }}
                            </option>
                        </select>
                    </div>
                </div>
                <div v-else class="col-10">
                    <div class="form-group">
                        <label>{{ __("forms.KPISegments.typology") }}</label>
                        <select class="form-control" disabled required name="kPISegment[typology]"
                            v-model="dataSegmentation.typology">
                            <option v-for="(typology) in typologies" disabled :value="typology.id"
                                v-bind:key="typology.id">
                                {{ typology.value }}
                            </option>
                        </select>
                        <input name="kPISegment[typology]" :value="dataSegmentation.typology" type="hidden">
                    </div>
                </div>
                <div class="col-1" v-if="dataSegmentation.type_segments != 'line'">
                    <button type="button" style="margin-top: 23px;"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mx-1 hrt-button"
                        @click="openNote(__('forms.KPISegments.explain_typology_calculation'))">
                        <i class="fas fa-info-circle"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Manuale / Automatica -->
        <div class="form-group" v-if="dataSegmentation.typology == 'number'">
            <div class="row">
                <div class="col-10">
                    <input type="checkbox" name="kPISegment[automatic_percentage_calculation]" value="1"
                        v-model="dataSegmentation.automatic_percentage_calculation" :disabled="is_archived">
                    <label>{{ __("forms.KPISegments.automatic_percentage_calculation") }}</label>
                </div>
                <div class="col-1">
                    <button type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history mx-1 hrt-button"
                        @click="openNote(__('forms.KPISegments.explain_auto_calculation'))">
                        <i class="fas fa-info-circle"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group" v-else>
            <input type="checkbox" disabled>
            <label>{{ __("forms.KPISegments.automatic_percentage_calculation") }}</label>
        </div>

        <!-- Standard / Non Standard -->
        <div class="form-group">
            <input type="checkbox" name="kPISegment[is_standard]" value="1" v-model="dataSegmentation.is_standard"
                :disabled="is_archived">
            <label>{{ __("forms.KPISegments.is_standard") }}</label>
        </div> 

        <!-- Segmentazione origianle standard -->
        <div class="form-group">
            <label> {{ __("forms.KPISegments.origin_segmentation_standard") }}</label>
            <select class="form-control" name="kPISegment[standard_segment_id]"
                v-model="dataSegmentation.standard_segment_id" :disabled="is_archived">
                <option value="">{{ __("misc.select") }}</option>
                <option v-for="standard in standard_segmentations" :value="standard.id">
                    {{ standard.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.dataSegmentation = { ...this.dataSegmentation, ...this.kpi_segment };
    },
    props: {


        typologies: {
            type: Array,
            required: true
        },
        standard_segmentations: {
            type: Array,
            required: true
        },
        kpi_segment: {
            type: [Object, Array],
            required: true
        },
        is_persisted: {
            type: Boolean,
            required: true
        },
        is_archived: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            dataSegmentation: {
                name: '',
                type_segments: '',
                typology: '',
                automatic_percentage_calculation: false,
                is_standard: false,
                standard_segment_id: '',
            }
        }
    },
    methods: {
        setStaticTypology() {
            if (!this.is_persisted && this.dataSegmentation.type_segments == 'line' && this.dataSegmentation.typology == 'text') {
                this.dataSegmentation.typology = '';
            }
        },
        openNote(note) {
            Vue.swal.fire({
                title: note,
            });
        },
    }
}
</script>

<style></style>
